export enum APP_ENV {
	Latam = 1,
	Domestic = 2
}

export const ENV_BLOCKED_ACCESS: any = [
	{
		'env': APP_ENV.Latam,
		'pages': []
	},
	{
		'env': APP_ENV.Domestic,
		'pages': [28, 29, 37, 4, 5, 36, 19]
	}
]